import urlConstants from '~/lib/constants/url.constants';
import {
  CreateTreatmentSummaryRequest,
  CreateTreatmentSummaryResponse,
  ValidateTreatmentSummaryRequest,
  ValidateTreatmentSummaryResponse,
} from '~/lib/types/patient/treatmentSummary';
import { transformValidateResponse } from '~/lib/util/treatmentSummary.util';

import { HttpRequestMethod } from '~/store';

import api from '../api';
import { CacheTag } from '../CacheTag';

export const treatmentSummaryApi = api.injectEndpoints({
  endpoints: (build) => ({
    createTreatmentSummary: build.mutation<
      CreateTreatmentSummaryResponse,
      CreateTreatmentSummaryRequest
    >({
      invalidatesTags: [CacheTag.PatientDocuments],
      query: ({ patientMrn, patientExternalId }) => ({
        body: { patientExternalId },
        method: HttpRequestMethod.POST,
        url: urlConstants.clinical_data.treatment_summary.create(patientMrn),
      }),
    }),
    validateTreatmentSummary: build.query<
      ValidateTreatmentSummaryResponse,
      ValidateTreatmentSummaryRequest
    >({
      keepUnusedDataFor: 0,
      query: ({ patientMrn }) => ({
        method: HttpRequestMethod.GET,
        url: urlConstants.clinical_data.treatment_summary.validate(patientMrn),
      }),
      transformResponse: transformValidateResponse,
    }),
  }),
});

export const {
  useCreateTreatmentSummaryMutation,
  useLazyValidateTreatmentSummaryQuery,
} = treatmentSummaryApi;
